



























































































import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbAlert } from '@folky-tools/mdbvue';
import {
    getOrganizationBusinessPricingsFromMainProject,
    requestOrganizationBusinessChangeOfPricing,
    RequestOrganizationBusinessChangeOfPricingDto,
    notificationsService,
    GetOrganizationBusinessPricingsFromMainProjectDto,
    GetOrganizationBusinessPricingsFromMainProjectNameToDisplayDto,
    GetOrganizationBusinessPricingsFromMainProjectDescriptionToDisplayDto,
    VisibilityModes
} from '@/services';
import { BusinessSubscriptionViewModel } from '@/models/businesses/business-subscription-view';
import { BusinessSubscriptionPricingViewModel } from '@/models/businesses/business-subscription-pricing';
import { BusinessSubscriptionNameToDisplayViewModel } from '@/models/businesses/business-subscription-name-to-display';
import { BusinessSubscriptionDescriptionToDisplayViewModel } from '@/models/businesses/business-subscription-description-to-display';
import Swal from 'sweetalert2';

@Component({
    components: {
        mdbBtn,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbAlert,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        EditPickupAddress: () => import('@/components/businesses/EditPickupAddress.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessSubscriptionView extends Vue {
    private businessSubscriptionViewModel: BusinessSubscriptionViewModel = new BusinessSubscriptionViewModel();
    private changePlanBtnsAreVisible: boolean = true;
    private planBusinessEvolvingTo: string = '';

    private async created(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessSubscriptionView.title', this.$route.query.businessName ? this.$route.query.businessName : '...');

        const businessId = this.getBusinessIdFromRouteParamsWithoutNaNError();
        const data = await getOrganizationBusinessPricingsFromMainProject.execute(businessId);
        const allPricings = data.map((p: GetOrganizationBusinessPricingsFromMainProjectDto) => {
            const names = p.namesToDisplay.map((n: GetOrganizationBusinessPricingsFromMainProjectNameToDisplayDto) => new BusinessSubscriptionNameToDisplayViewModel(n.culture, n.name));
            const descs = p.descriptionsToDisplay.map((d: GetOrganizationBusinessPricingsFromMainProjectDescriptionToDisplayDto) => new BusinessSubscriptionDescriptionToDisplayViewModel(d.culture, d.description));
            return new BusinessSubscriptionPricingViewModel(p.pricingId, p.isBusinessSubscribedTo, p.priceBase, p.priceFinal, p.discount, p.level, names, descs, p.visibility);
        });
        const visiblePricings = allPricings.filter(pp => pp.visibility === VisibilityModes.NoRestriction);
        this.businessSubscriptionViewModel = new BusinessSubscriptionViewModel(visiblePricings);
    }

    private getBusinessIdFromRouteParamsWithoutNaNError(): number {
        return +this.$route.params.id;
    }

    private async requestPlanChange(pricingId: number, displayName: string): Promise<void> {
        const questionResult = await Swal.fire({
            title: this.$i18n.t('views.businesses.businessSubscriptionView.confirmPlanChangeRequest.title').toString(),
            html: this.$i18n
                .t('views.businesses.businessSubscriptionView.confirmPlanChangeRequest.html')
                .toString()
                .replace('{0}', (this.$route.query.businessName ? this.$route.query.businessName : '...').toString())
                .replace('{1}', displayName),
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: true,
            confirmButtonText: this.$i18n.t('views.businesses.businessSubscriptionView.confirmPlanChangeRequest.doConfirm').toString(),
            cancelButtonText: this.$i18n.t('views.businesses.businessSubscriptionView.confirmPlanChangeRequest.doCancel').toString(),
            customClass: {
                confirmButton: 'btn btn-primary trigger trigger-confirm-plan-change trigger-confirm-change-to-plan-' + pricingId,
                cancelButton: 'btn btn-danger trigger trigger-cancel-plan-change trigger-cancel-change-to-plan-' + pricingId
            },
            animation: false
        });

        if (questionResult.value) {
            const pricingChangeData: RequestOrganizationBusinessChangeOfPricingDto = new RequestOrganizationBusinessChangeOfPricingDto(this.getBusinessIdFromRouteParamsWithoutNaNError(), pricingId);
            try {
                await requestOrganizationBusinessChangeOfPricing.execute(pricingChangeData);
                notificationsService.showToastSuccessNotification('views.businesses.businessSubscriptionView.notifications.planChangeRequestSuccess');
                this.planBusinessEvolvingTo = displayName;
                this.changePlanBtnsAreVisible = false;
            } catch {
                notificationsService.showToastErrorNotification();
            }
        }
    }
}
